export const SELLER = "البائع";
export const BUYER = "المشتري";
export const WRITE_REASONS = "اكتب اسباب الرفض";
export const ESCALATE_TO_WAFFY = "التصعيد لوفّي";

export const ESCALATION_REASONS = [
  {
    key: "product_not_delivered",
    value: "لم أستلم المنتج بعد",
  },
  {
    key: "product_not_identical_with_description",
    value: "المنتج غير متطابق مع الوصف",
  },
  { key: "product_not_working", value: "المنتج تالف/لا يعمل" },
  {
    key: "product_has_cracks_and_defects",
    value: "المنتج به عيوب وكسور",
  },
];
